"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4433%3A479))
 * @trackcomponent
 * @lastsynced 2023-10-27T16:52:43.881Z
 */
export const ThumbsUp = createSVGIcon(
  <>
    <path
      d="M2.21851 10.0515H6.08132V20.3361H2.21851C2.00237 20.3361 1.79509 20.2502 1.64225 20.0974C1.48942 19.9445 1.40356 19.7373 1.40356 19.5211V10.8665C1.40356 10.6503 1.48942 10.443 1.64225 10.2902C1.79509 10.1374 2.00237 10.0515 2.21851 10.0515Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.0813 10.051L10.2212 3.43367C10.3816 3.17213 10.6071 2.95659 10.8756 2.80806C11.1441 2.65953 11.4465 2.58308 11.7533 2.58614C11.9949 2.57742 12.2359 2.61722 12.4619 2.70321C12.6879 2.7892 12.8943 2.91961 13.0691 3.08675C13.2438 3.25389 13.3833 3.45436 13.4792 3.67632C13.5751 3.89827 13.6256 4.13721 13.6276 4.37901V9.12195H20.7828C21.0472 9.13053 21.3067 9.19496 21.5445 9.31104C21.7822 9.42711 21.9926 9.59217 22.162 9.79539C22.3314 9.99861 22.4558 10.2354 22.5271 10.4901C22.5984 10.7448 22.6149 11.0118 22.5757 11.2734L21.2717 19.6836C21.2162 20.1331 20.9982 20.5467 20.6591 20.8469C20.32 21.147 19.8829 21.313 19.4299 21.3135H8.738C8.22902 21.3154 7.72665 21.1983 7.27111 20.9711L6.0976 20.3844"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.0813 10.0513V20.3358"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "ThumbsUp",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
